import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import apiAuth from "../../helpers/ApiAuth";
import { reMapGetEmployeesData } from "./normalizers";
import {
  GET_EMPLOYEE,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_ERROR,
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_ERROR,
  EDIT_EMPLOYEE,
  EDIT_EMPLOYEE_SUCCESS,
  EDIT_EMPLOYEE_ERROR,
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_ERROR,
  EMPLOYEE_ACTION_ERROR,
  LOGOUT_USER,
  GET_EMPLOYEE_SUMMARY,
  GET_EMPLOYEE_SUMMARY_SUCCESS,
  GET_EMPLOYEE_SUMMARY_ERROR,
} from "../actions";

export function* watchActionError() {
  yield takeEvery(EMPLOYEE_ACTION_ERROR, ActionError);
}

function* ActionError(message) {
  try {
    if (message.payload.response.status === 401) {
      yield put({ type: LOGOUT_USER });
    }

    yield put({
      type: message.payload.action,
      payload: message.payload.response,
    });
  } catch (error) {}
}

export function* watchGetEmployee() {
  yield takeEvery(GET_EMPLOYEE, getEmployee);
}

const getEmployeeDataAsync = async () =>
  await apiAuth
    .get("/api/employee/")
    .then((employees) => employees.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* getEmployee() {
  try {
    const employees = yield call(getEmployeeDataAsync);

    if (!employees.message) {
      const payload = reMapGetEmployeesData(employees);
      yield put({ type: GET_EMPLOYEE_SUCCESS, payload: payload });
    } else {
      employees.message.action = GET_EMPLOYEE_ERROR;
      yield put({ type: EMPLOYEE_ACTION_ERROR, payload: employees.message });
    }
  } catch (error) {
    yield put({ type: GET_EMPLOYEE_ERROR, payload: error });
  }
}

export function* watchAddEmployee() {
  yield takeEvery(ADD_EMPLOYEE, addEmployee);
}

function* addEmployee(employeeObj) {
  try {
    yield put({ type: ADD_EMPLOYEE_SUCCESS, payload: employeeObj.payload });
  } catch (error) {
    yield put({ type: ADD_EMPLOYEE_ERROR, payload: error });
  }
}

export function* watchEditEmployee() {
  yield takeEvery(EDIT_EMPLOYEE, editEmployee);
}

function* editEmployee(employeeObj) {
  try {
    yield put({ type: EDIT_EMPLOYEE_SUCCESS, payload: employeeObj.payload });
  } catch (error) {
    yield put({ type: EDIT_EMPLOYEE_ERROR, payload: error });
  }
}

export function* watchDeleteEmployee() {
  yield takeEvery(DELETE_EMPLOYEE, deleteEmployee);
}

const deleteEmployeeAsync = async (employee) =>
  await apiAuth
    .delete(`/api/employee/${employee.id}/`)
    .then((employee) => employee)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteEmployee(employeeObj) {
  try {
    const employee = yield call(deleteEmployeeAsync, employeeObj.payload);

    if (!employee.message) {
      yield put({
        type: DELETE_EMPLOYEE_SUCCESS,
        payload: employeeObj.payload.id,
      });
    } else {
      employee.message.action = DELETE_EMPLOYEE_ERROR;
      yield put({ type: EMPLOYEE_ACTION_ERROR, payload: employee.message });
    }
  } catch (error) {
    yield put({ type: DELETE_EMPLOYEE_ERROR, payload: error });
  }
}

export function* watchGetEmployeeSummary() {
  yield takeEvery(GET_EMPLOYEE_SUMMARY, GetEmployeeSummary);
}

const GetEmployeeSummaryAsync = async (params) =>
  await apiAuth
    .get(`/api/summary/employee/`, params)
    .then((employee) => employee.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* GetEmployeeSummary(employeeObj) {
  try {
    const employee = yield call(GetEmployeeSummaryAsync, employeeObj.payload);

    if (!employee.message) {
      yield put({
        type: GET_EMPLOYEE_SUMMARY_SUCCESS,
        payload: employee,
      });
    } else {
      employee.message.action = GET_EMPLOYEE_SUMMARY_ERROR;
      yield put({ type: EMPLOYEE_ACTION_ERROR, payload: employee.message });
    }
  } catch (error) {
    yield put({ type: GET_EMPLOYEE_SUMMARY_ERROR, payload: error });
  }
}

export default function* rootSaga() {
  yield all([fork(watchActionError)]);
  yield all([fork(watchGetEmployee)]);
  yield all([fork(watchAddEmployee)]);
  yield all([fork(watchDeleteEmployee)]);
  yield all([fork(watchEditEmployee)]);
  yield all([fork(watchGetEmployeeSummary)]);
}
